import { Component, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { Globals } from '../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, AfterContentInit, OnDestroy {
    public connect;
    public data;
    public support: any = { key: 'footersupport', list: [], title: 'footerSupport' };
    public token: any = {
        menu: "api/getmenu",
    }
    constructor(
        public globals: Globals,
        public translate: TranslateService,
        public router: Router,
        private http: Http,
    ) {
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "menufootersupport":
                    if (res.status == 1) {
                        this.support.list = res.data
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.globals.send({ path: this.token.menu, token: 'menufootersupport', params: { position: 'footersupport' } });
    }
    
    ngOnDestroy() {
        this.connect.unsubscribe();
    }
    ngAfterContentInit() {
        setTimeout(() => {
            if(window['runHistats']){
                window['runHistats']();
            }
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/footer/footer.component.ts